/**
 * WordPress Dependencies
 */
import { __ } from '@wordpress/i18n';
import { registerPlugin } from '@wordpress/plugins';
import { useSelect, useDispatch } from '@wordpress/data';
import { PluginDocumentSettingPanel } from '@wordpress/edit-post';

/**
 * Custom Dependencies
 */
import { PositionsControl } from '../components';

const META_KEY = 'automatic-block-position';

registerPlugin('automatic-block-inserter-positions', {
	render: () => {
		const { position } = useSelect((select) => {
			const postMeta =
				select('core/editor').getEditedPostAttribute('meta');

			return {
				position: JSON.parse(postMeta[META_KEY]),
			};
		}, []);

		const { editPost } = useDispatch('core/editor');

		return (
			<PluginDocumentSettingPanel
				name="automatic-block-inserter-positions"
				title={__('Position', 'automatic-block-inserter')}
			>
				<PositionsControl
					value={position}
					onChange={(newPosition) =>
						editPost({
							meta: { [META_KEY]: JSON.stringify(newPosition) },
						})
					}
				/>
			</PluginDocumentSettingPanel>
		);
	},
});
